import React from 'react';
import { ParallaxBackground } from './ParallaxBackground';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative w-full h-[100svh] min-h-[600px] pt-[60px] md:pt-[80px]" data-id="element-117">
      <ParallaxBackground imageUrl="https://cdn.magicpatterns.com/uploads/nSKWmRCRa62U2kdHAAC97c/emilie-PCEYPtW3vN8-unsplash.jpg" imageAlt="Sand-toned paver walkway lined with lush tropical greenery" className="absolute inset-0" overlayOpacity={0} data-id="element-118" />

      {/* Directional overlay: top-to-bottom on mobile (text stacks full width) */}
      <div className="absolute inset-0 z-[5] pointer-events-none md:hidden" style={{
      background: 'linear-gradient(to bottom, rgba(15,23,30,0.92) 0%, rgba(15,23,30,0.75) 35%, rgba(15,23,30,0.35) 70%, rgba(15,23,30,0.15) 100%)'
    }} data-id="element-119" />
      {/* Directional overlay: left-to-right on tablet/desktop (text side stays dark) */}
      <div className="absolute inset-0 z-[5] pointer-events-none hidden md:block" style={{
      background: 'linear-gradient(to right, rgba(15,23,30,0.92) 0%, rgba(15,23,30,0.75) 35%, rgba(15,23,30,0.35) 65%, rgba(15,23,30,0.1) 100%)'
    }} data-id="element-120" />
      {/* Subtle bottom-up darkening for the CTA area */}
      <div className="absolute inset-0 z-[5] pointer-events-none" style={{
      background: 'linear-gradient(to top, rgba(15,23,30,0.7) 0%, rgba(15,23,30,0) 45%)'
    }} data-id="element-121" />

      <div className="relative z-10 container mx-auto px-4 h-full flex flex-col justify-center pb-12 md:pb-0" data-id="element-122">
        <div className="max-w-3xl" data-id="element-123">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="text-[32px] leading-[1.1] md:text-5xl lg:text-7xl font-extrabold text-white font-heading tracking-tight mb-6 [text-shadow:0_2px_12px_rgba(0,0,0,0.5)]" data-id="element-124">
            Las Vegas Pavers, Turf & Pool Decks{' '}
            <span className="text-teal" data-id="element-125">Done Right.</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: 'easeOut'
        }} className="text-lg md:text-xl text-white mb-8 md:mb-10 max-w-2xl leading-relaxed [text-shadow:0_2px_12px_rgba(0,0,0,0.5)]" data-id="element-126">
            Premium outdoor living transformations across Las Vegas, North Las
            Vegas & Henderson. Quality stone, expert installation, and free
            estimates.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-127">
            <Button asChild size="lg" className="bg-teal hover:bg-teal-dark text-white font-bold h-12 md:h-14 px-8 text-base w-full sm:w-auto" data-id="element-128">
              <a href="#contact" data-id="element-129">Get a Free Estimate</a>
            </Button>
            <Button asChild size="lg" className="bg-white border-2 border-white text-charcoal hover:bg-sand hover:border-sand font-bold h-12 md:h-14 px-8 text-base w-full sm:w-auto" data-id="element-130">
              <a href="#work" data-id="element-131">View Our Work</a>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}